import { DISMISS_STATE_KIND } from './DISMISS_STATE_KIND';
import type { DismissState } from './DismissState';

export const createTimerRunningState = (
	firstViewedAt: number,
	sourcesClickedAt: number,
): DismissState => ({
	kind: DISMISS_STATE_KIND.TIMER_RUNNING,
	firstViewedAt,
	sourcesClickedAt,
});
